import InUse from "../images/WorkTable/1InUse.jpeg";
import Prototype1 from "../images/WorkTable/2Prototype1.jpeg";
import Prototype2 from "../images/WorkTable/3Prototype2.jpeg";
import Rendering from "../images/WorkTable/4Rendering.jpeg";
import Wood from "../images/WorkTable/5Wood.jpeg";
import Frame from "../images/WorkTable/6Frame.jpeg";
import Jig from "../images/WorkTable/6PocketHoleJig.jpeg";
import PocketHoles from "../images/WorkTable/7PocketHoles.jpeg";
import TopGluing from "../images/WorkTable/7TopGluing.jpeg";
import MorePocketHoles from "../images/WorkTable/8MorePocketHoles.jpeg";
import CloseUp1 from "../images/WorkTable/9CloseUpPcktHole.jpeg";
import Structure from "../images/WorkTable/10Structure.jpeg";
import CloseUp2 from "../images/WorkTable/11CloseUp2.jpeg";
import Trim from "../images/WorkTable/11Trim.jpeg";
import Patching from "../images/WorkTable/12Patching.jpeg";
import Bracket from "../images/WorkTable/13Bracket.jpeg";
import Slideout from "../images/WorkTable/14Slideout.jpeg";
import Mechanism from "../images/WorkTable/15Mechanism.jpeg";
import Paint from "../images/WorkTable/16Paint.jpeg";

const WorkTableImages = [
  {
    src: InUse,
    text: "Somehow I didn't have any photos of the finished product other than this one of the table in use in my Chicago apartment. Alas, it is now inaccessible in a storage unit after moving. Almost visible is the removeable shelf that rests on the lower side supports."
  },
  {
    src: Prototype1,
    text: "The first cardboard prototype I built."
  },
  {
    src: Prototype2,
    text: "The second cardboard prototype showing the slide-out idea."
  },
  {
    src: Rendering,
    text: "I used Solidworks to create a 3D rendering of the table before the slide-out idea came along."
  },
  {
    src: Wood,
    text: "I sourced the straightest, most quality piece I could."
  },
  {
    src: Frame,
    text: "The lower structure of the table."
  },
  {
    src: Jig,
    text: "I used a pocket hole jig to drill all the pocket holes."
  },
  {
    src: PocketHoles,
    text: "A view of some of the pocket holes I drilled."
  },
  {
    src: TopGluing,
    text: "Making sure the top is securely glued in place."
  },
  {
    src: MorePocketHoles,
    text: "Here, I secure the single pocket hole jig in place with a clamp so I can drill them."
  },
  {
    src: CloseUp1,
    text: "A close up view of a single pocket hole."
  },
  {
    src: Structure,
    text: "The basic structure of the table with the top attached."
  },
  {
    src: CloseUp2,
    text: "More pocket holes!"
  },
  {
    src: Trim,
    text: "My dad suggested I add trim to the sides for a more finished look."
  },
  {
    src: Patching,
    text: "I patched the finish nail holes with wood putty so they would become invisible."
  },
  {
    src: Bracket,
    text: "I attached brackets to the back of the slide-out so it wouldn't pull out of the table completely."
  },
  {
    src: Slideout,
    text: "The slideout works by holding up two legs with a twisting parallel piece that keeps them in place when the slide-out is not in use."
  },
  {
    src: Mechanism,
    text: "Here you can see that the slide-out rests on pieces of wood attached to the legs of the table."
  },
  {
    src: Paint,
    text: "I wanted the paint for this project to match the previous bookcase project."
  }
]

export default WorkTableImages;